export const FAIR_PLAY_LINK = 'https://hc.cian.ru/hc/ru/articles/360020818871';
